module.exports = __webpack_public_path__ + "static/img/bicon29.437f9be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bicon29.png
// module id = 301
// module chunks = 3